import { useState } from "react";
import { useTranslation } from "react-i18next";
import { cn } from "../tokens";
export interface TabModel { id: string; title: string; }
interface Props { tabs: TabModel[]; activeId: string|null; onActivate:(id:string)=>void; onClose:(id:string)=>void; onRename:(id:string,title:string)=>void; }
export function PageTabs({ tabs, activeId, onActivate, onClose, onRename }: Props) {
  const { t } = useTranslation("common");
  const [editing, setEditing] = useState<string|null>(null);
  const [draft, setDraft] = useState("");
  return (
    <div className="flex items-stretch gap-px overflow-x-auto border-b border-[var(--color-border)] bg-[var(--color-surface-container-low)]">
      {tabs.map((tab) => {
        const active = tab.id === activeId;
        return (
          <div key={tab.id} onClick={() => onActivate(tab.id)}
            onDoubleClick={() => { setEditing(tab.id); setDraft(tab.title); }}
            className={cn("group flex max-w-[240px] cursor-pointer items-center gap-2 border-r border-[var(--color-border)] px-3 py-2 text-sm",
              active ? "bg-[var(--color-surface)] text-[var(--color-on-surface)]"
                     : "text-[var(--color-on-surface-variant)] hover:bg-[var(--color-surface-variant)]")}>
            {editing === tab.id ? (
              <input autoFocus value={draft} onChange={(e) => setDraft(e.target.value)}
                onBlur={() => { onRename(tab.id, draft.trim() || tab.title); setEditing(null); }}
                onKeyDown={(e) => { if (e.key==="Enter") (e.target as HTMLInputElement).blur(); if (e.key==="Escape") setEditing(null); }}
                className="w-32 bg-transparent text-sm outline-none" />
            ) : <span className="truncate">{tab.title}</span>}
            <button onClick={(e) => { e.stopPropagation(); onClose(tab.id); }}
              className="rounded px-1 text-[var(--color-on-surface-variant)] opacity-0 transition-opacity hover:bg-[var(--color-surface-bright)] group-hover:opacity-100"
              aria-label={t("closeTab")}>×</button>
          </div>
        );
      })}
    </div>
  );
}
